import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FilterCompleteService } from 'src/app/filter-complete/filter-complete';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { ServiceFilter } from 'src/app/model/service-filter';
import { PracticeRegionFilter } from 'src/app/model/practice-region-filter';
import { FilterService } from 'src/app/services/filter.service';
import { AuthService } from 'src/app/services/auth.service';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { MedicalAppointmentWaitState } from 'src/app/model/medical-appointment/medical-appointment-wait-state';
import { Center } from 'src/app/model/center';
import { CenterFilter } from 'src/app/model/center-filter';

@Component({
  selector: 'app-medical-appointment-wait-filter',
  templateUrl: './medical-appointment-wait-filter.component.html',
  styleUrls: ['./medical-appointment-wait-filter.component.css']
})
export class MedicalAppointmentWaitFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  filterCompleteServices: FilterCompleteService<ServiceFilter>;
  filterCompletePracticesRegion: FilterCompleteService<PracticeRegionFilter>;
  filterCompleteMedicalAppointmentWaitState: FilterCompleteService<MedicalAppointmentWaitState>;
  filterCompleteCenter: FilterCompleteService<CenterFilter>;


  constructor(private formBuilder: FormBuilder
    , private filterService: FilterService
    , private reservationService: ReservationService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      DateFrom: [new Date(), [Validators.required]],
      DateTo: [new Date(), [Validators.required]],
      Service: [''],
      PracticeRegion: [''],
      Patient: [null],
      MedicalAppointmentWaitState: [null],
      Center: [null],
      OnlyInterned: [false]
    });

    this.filterCompleteServices = new FilterCompleteService<ServiceFilter>([], this.form.controls.Service);
    this.filterCompletePracticesRegion = new FilterCompleteService<PracticeRegionFilter>([], this.form.controls.PracticeRegion);
    this.filterCompleteMedicalAppointmentWaitState = new FilterCompleteService<MedicalAppointmentWaitState>([], this.form.controls.MedicalAppointmentWaitState);
    this.filterCompleteCenter = new FilterCompleteService<CenterFilter>([], this.form.controls.Center);
  }

  get filteredCenterOptions() {
    return this.filterCompleteCenter ? this.filterCompleteCenter.filteredOptions : []; }
  get filteredMedicalAppointmentWaitStateOptions() {
    return this.filterCompleteMedicalAppointmentWaitState ? this.filterCompleteMedicalAppointmentWaitState.filteredOptions : []; }
  get filteredServicesOptions() {
    return this.filterCompleteServices ? this.filterCompleteServices.filteredOptions : []; }
  get filteredPracticesRegionOptions() {
    return this.filterCompletePracticesRegion ? this.filterCompletePracticesRegion.filteredOptions : []; }
  get f() {
    return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push('Date');
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('MedicalAppointmentWaitFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('MedicalAppointmentWaitFilterComponent', this.form);
  }

  async search(): Promise<any> {
    const serviceId = (this.form.controls.Service.value ? this.form.controls.Service.value.Id : null);
    const centerId = (this.form.controls.Center.value ? this.form.controls.Center.value.Id : null);
    const onlyInterned = this.form.controls.OnlyInterned.value;
    return await this.reservationService.getMedicalAppointmentWaitSearchItems(
      <Date>this.form.controls.DateFrom.value,
      <Date>this.form.controls.DateTo.value,
      (this.form.controls.PracticeRegion.value ? this.form.controls.PracticeRegion.value.Id : null),
      (this.form.controls.MedicalAppointmentWaitState.value ? this.form.controls.MedicalAppointmentWaitState.value.Id : null),
      (this.form.controls.Patient.value ? this.form.controls.Patient.value.Id : null),
      serviceId,
      centerId,
      onlyInterned );
  }

  ngOnInit() {
    this.filterService.getServicesFilter().then((services) => {
      this.filterCompleteServices =
      new FilterCompleteService<ServiceFilter>(services, this.form.controls.Service);
    });

    this.filterService.getMedicalAppointmentWaitStates().then((data) => {
      this.filterCompleteMedicalAppointmentWaitState =
      new FilterCompleteService<MedicalAppointmentWaitState>(data, this.form.controls.MedicalAppointmentWaitState);
    })

    this.filterService.getPracticesRegionFilter().then((practicesRegion) => {
      this.filterCompletePracticesRegion =
      new FilterCompleteService<PracticeRegionFilter>(practicesRegion, this.form.controls.PracticeRegion);
    });

    this.filterService.getCentersFilter().then((centers) => {
      this.filterCompleteCenter =
      new FilterCompleteService<CenterFilter>(centers, this.form.controls.Center);
    });
  }
}
